// extracted by mini-css-extract-plugin
export default {"list":"KVC17xjWi54ILeT4hK1_","ivMessage":"Soc5DPjxrsI5WukOANEZ"};